import * as logisticServices from './logisticServices';

const reducers = {
  ...logisticServices,
};

export default reducers;
